import { LeaderboardMetric } from 'fitbeat.models';
import React from 'react';
import { metricInfo } from '../leaderboardUIHelper';

interface IProps {
  isOpen: boolean,
  metric: LeaderboardMetric,
  closeModal: () => void;
}

const LeaderboardMetricInfoModal: React.FC<IProps> = ({
  isOpen,
  metric,
  closeModal,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <h2>Information</h2>
        <p style={{ whiteSpace: 'pre-line' }}>{metricInfo(metric)}</p>
        <button onClick={closeModal} className='jr-btn-default'>Close</button>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '300px',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  closeButton: {
    padding: '8px 16px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default LeaderboardMetricInfoModal;
